// extracted by mini-css-extract-plugin
module.exports = {"upload-wrapper":"upload-wrapper--1ekI3DHP","gpy-border-wrapper":"gpy-border-wrapper--1kmNEb_2","uploader-tooltip":"uploader-tooltip--1P79H5Ix"};